import { getSortedCollection, SprintQueryResult, useSprintQuery } from "sprint-common-web";

import { useOrdersAirlineApi } from "../../../../../common/api/orders-api/airline/useOrdersAirlineApi";
import { DataHooksQueryKey } from "../../../../../common/data/data-hooks/DataHooksQueryKey";
import { mapToOrdersAirline, OrdersAirline } from "../../../../common/types/OrdersAirline";

export const useOrderAirlines = (): SprintQueryResult<OrdersAirline[]> => {
    const { getOrdersAirlinesLookup } = useOrdersAirlineApi();

    return useSprintQuery<OrdersAirline[]>({
        queryKey: [DataHooksQueryKey.OrderAirlines],
        queryFn: async (): Promise<OrdersAirline[]> => {
            const response = await getOrdersAirlinesLookup();
            const newItems = response.items.map(mapToOrdersAirline);
            return getSortedCollection(newItems, "name");
        }
    });
};
